import { lazy } from "react";

const List = lazy(() => import("./List"));
const Create = lazy(() => import("./Create"));

export { List, Create };
